import { DOWNSTREAM, UPSTREAM, KEY_LINE, NODES } from "./data";

export const TwoWayModel = () => (
    <section className="rounded-sm border border-slate-200 bg-white p-8" data-testid="two-way-model">
        <p className="font-mono text-xs uppercase tracking-[0.14em] text-slate-400">
            Core two-direction model
        </p>
        <h2 className="mt-3 text-2xl font-medium tracking-tight text-slate-900">
            The change travels down. Evidence travels back up.
        </h2>

        <div className="mt-8 grid gap-8 lg:grid-cols-[1fr_auto_1fr]">
            <div data-testid="two-way-downstream">
                <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-blue-900">
                    Downstream — authorised change travels out
                </p>
                <div className="mt-3 flex flex-col gap-px overflow-hidden rounded-sm border border-slate-200 bg-slate-200">
                    {DOWNSTREAM.map((s, i) => (
                        <div key={s} className="flex items-center gap-3 bg-white px-4 py-2.5">
                            <span className="font-mono text-[10px] text-slate-300">{String(i + 1).padStart(2, "0")}</span>
                            <span className="font-mono text-xs tracking-tight text-slate-800">{s}</span>
                            {i < DOWNSTREAM.length - 1 && <span className="ml-auto text-slate-300">↓</span>}
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-3">
                <div className="rounded-sm bg-blue-950 px-4 py-3 text-center" data-testid="two-way-manufacturer">
                    <p className="text-sm font-medium text-white">Product Manufacturer</p>
                    <p className="mt-0.5 font-mono text-[10px] uppercase tracking-wide text-blue-200">
                        Publishes the bounded change package
                    </p>
                </div>
                <div className="flex flex-col items-center font-mono text-[10px] uppercase tracking-wide text-slate-400">
                    <span>↓ bounded change packages</span>
                    <span>↑ bounded receipts</span>
                </div>
                <div className="grid grid-cols-2 gap-1.5" data-testid="two-way-participants">
                    {NODES.filter((n) => n.id !== "mfr").map((p) => (
                        <div
                            key={p.id}
                            className="rounded-sm border-2 border-dashed border-slate-300 bg-white px-2.5 py-2 text-center"
                        >
                            <p className="text-xs font-medium text-slate-800">{p.short}</p>
                            <p className="font-mono text-[9px] uppercase tracking-wide text-slate-400">
                                Locally operated role node
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            <div data-testid="two-way-upstream">
                <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-green-800">
                    Upstream — bounded evidence returns
                </p>
                <div className="mt-3 flex flex-col gap-px overflow-hidden rounded-sm border border-slate-200 bg-slate-200">
                    {UPSTREAM.map((s, i) => (
                        <div key={s} className="flex items-center gap-3 bg-white px-4 py-2.5">
                            <span className="font-mono text-[10px] text-slate-300">{String(i + 1).padStart(2, "0")}</span>
                            <span className="font-mono text-xs tracking-tight text-slate-800">{s}</span>
                            {i < UPSTREAM.length - 1 && <span className="ml-auto text-slate-300">↑</span>}
                        </div>
                    ))}
                </div>
            </div>
        </div>

        <p
            className="mt-8 border-l-2 border-blue-950 pl-4 text-sm font-medium leading-relaxed text-slate-900"
            data-testid="two-way-key-line"
        >
            {KEY_LINE}
        </p>
        <p className="mt-3 text-xs leading-relaxed text-slate-500">
            Messages, decisions and receipts move across the network. Raw
            organisational evidence does not. Every role node has a visible custody
            boundary — there is no central workflow engine deciding for all
            organisations.
        </p>
    </section>
);
